import { render } from "./AutoPurchaseForm.vue?vue&type=template&id=398f23fc&scoped=true"
import script from "./AutoPurchaseForm.vue?vue&type=script&lang=js"
export * from "./AutoPurchaseForm.vue?vue&type=script&lang=js"

import "./AutoPurchaseForm.vue?vue&type=style&index=0&id=398f23fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398f23fc"]])

export default __exports__